<template>
  <card :has-settings="false" :has-subtitle="false" auto-height title="Announcement">
    <template #content>
      <validation-observer class="form" v-slot="{ handleSubmit }">
        <input-with-validation b-name="select" field-label="Language" rules="required" expanded v-model="language">
          <option :value="null">Select Language</option>
          <option v-for="(lang, index) in langs" :key="index" :value="lang">{{ lang }}</option>
        </input-with-validation>

        <input-with-validation :disabled="hasCustomMessage || undefined" b-name="select" :rules="hasCustomMessage ? '' : 'required'" field-label="Message" expanded v-model="message">
          <option :value="null">Select Message</option>
          <option v-for="(msg, index) in messages" :key="index" :value="msg">{{ msg }}</option>
        </input-with-validation>
        <input-with-validation b-name="input" field-label="Custom Message"
                               expanded v-model="customMessage"
                               placeholder="Type a custom announcement..."
                               :icon-right="customMessage.length > 0 ? 'close-circle' : ''"
                               icon-right-clickable
                               @icon-right-click="() => customMessage = ''" />
        <button class="button is-primary is-rounded" :disabled="!canAnnounce" @click="handleSubmit(announce)">Play in Room</button>
      </validation-observer>
    </template>
  </card>
</template>

<script>
import Card from "@/components/card/Card";
import ValidationObserver from "@/components/validation/ValidationObserver";
import InputWithValidation from "@/components/validation/InputWithValidation";
import to from "@/lib/to";
export default {
  name: "Announcement",
  components: {InputWithValidation, ValidationObserver, Card},
  props: {
    monitorId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    hasCustomMessage() {
      return this.customMessage && this.customMessage.trim().length > 0
    },
    canAnnounce() {
      return this.language && (this.hasCustomMessage || this.message)
    }
  },
  methods: {
    async announce() {
      const payload = {
        lang: this.language,
        source: this.$helpers.getMonitoringSource()
      }
      if (this.hasCustomMessage) {
        payload.custom_message = this.customMessage.trim()
      } else {
        payload.announcement_name = this.message
      }
      const [err, ] = await to(this.$http.post(`/patient_monitors/${this.monitorId}/announce`, payload))
      if (!err) {
        this.$buefy.toast.open({
          message: "Announcement is playing in the room",
          type: 'is-success'
        })
      }
    }
  },
  async mounted() {
    const [err, response] = await to(this.$http.get(`/patient_monitors/${this.monitorId}`))
    if (!err) {
      const langCode = response.data.patient?.language?.alpha2
      this.language = this.langsMap[langCode] || 'English'
    }
  },
  data() {
    return {
      langs: [
        'Chinese - Cantonese',
        'Chinese - Mandarin',
        'English',
        'French',
        'Spanish',
        'Tagalog',
      ],
      langsMap: {
        'zh': 'Chinese - Mandarin',
        'en': 'English',
        'fr': 'French',
        'es': 'Spanish',
        'tl': 'Tagalog',
      },
      messages: [
        'A nurse is on the way',
        'Please do not remove or pull at your lines a nurse is coming to help',
        'Please remain calm help is on the way',
        'Please stay in bed a nurse is coming soon',
        'Please stay in bed',
        'Please stay in your bed',
        'Please stay in your chair a nurse is coming soon',
        'Please stay in your chair',
        'Please step away from the patient',
        'Security is on the way',
        'You are in a hospital a nurse is coming to explain'
      ],
      language: null,
      message: null,
      customMessage: ''
    }
  }
}
</script>

<style scoped>
  button {
    margin: auto;
  }
  .form :deep(div) {
    display: flex;
    flex-direction: column;
  }
</style>
